import { ImageBlock } from '@/components/common/ImageBlock'
import ReadmoreDesc from '@/components/common/ReadmoreDesc'
import RichText from '@/components/richText'
import { buttonVariants } from '@/components/ui/button-variants'
import { DetailsBlockProps } from '@/payload-types'
import { Language } from '@/types/language.types'
import { useParams } from 'next/navigation'
import LinkWrapper from '@/components/common/LinkWrapper'

type Props = DetailsBlockProps & {
  lang?: Language
}

export const DetailBlock: React.FC<Props> = ({
  title,
  img,
  desc,
  showTable,
  table,
  'cta-group': ctaGroup,
  lang,
}) => {
  const params = useParams<{ lang: Language }>()

  return (
    <div className='flex flex-col space-y-2'>
      <h2 className='text-2xl'>{title && title}</h2>

      {img && (img.external || img.internal) && (
        <div className='relative aspect-video overflow-hidden rounded-md'>
          <ImageBlock imageBlock={img} />
        </div>
      )}

      {desc && (
        <ReadmoreDesc className='lg:max-w-none'>
          <RichText data={desc} />
        </ReadmoreDesc>
      )}

      <div className='flex flex-col space-y-4'>
        {showTable && table && (
          <div className='mt-2 space-y-2 rounded-md bg-stone-100 px-4 py-2'>
            <p className='font-medium'>{table.title}</p>

            <span className='block h-0.5 w-full rounded-full bg-stone-200' />

            <div className='flex flex-col space-y-1'>
              {table.rows &&
                table.rows.length > 0 &&
                table.rows.map((row) => (
                  <div key={row.id} className='flex items-center justify-between text-sm'>
                    <p className='max-w-1/2 truncate'>{row.label}</p>
                    <p className='max-w-1/2 truncate font-medium'>{row.value}</p>
                  </div>
                ))}
            </div>
          </div>
        )}

        {ctaGroup?.map(({ id, link }) =>
          link?.enabled ? (
            <LinkWrapper key={id} link={link}>
              <span
                className={buttonVariants({
                  size: 'lg',
                  variant: 'secondary',
                  className: 'w-full',
                })}
              >
                {link.label}
              </span>
            </LinkWrapper>
          ) : null,
        )}
      </div>
    </div>
  )
}

export default DetailBlock
